import {useId,useState} from 'react';
import {ChevronDown} from 'lucide-react';

export default function DesktopNavGroup({title,children,collapsible=false,storageKey}) {
 const id=useId();
 const [open,setOpen]=useState(()=>{try{return localStorage.getItem(storageKey)!=='closed';}catch{return true;}});
 const toggle=()=>setOpen(previous=>{const next=!previous;try{localStorage.setItem(storageKey,next?'open':'closed');}catch{}return next;});
 return <section className="ref-nav-section">
  <h2>{collapsible?<button className="ref-nav-group-toggle" type="button" aria-expanded={open} aria-controls={id} onClick={toggle}><span>{title}</span><ChevronDown aria-hidden="true"/></button>:title}</h2>
  <div id={id} hidden={collapsible&&!open}>{children}</div>
 </section>;
}
